// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"6fae760d","902":"81f71e61"}[chunkId] + ".chunk.js";
};